"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class Level {
    async download() {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/services/level/download`, {
                method: 'GET',
                headers: { 'If-Modified-Since': '0' }
            }).fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to download level: status ${err.message}`);
        }
    }
}
exports.default = Level;
//# sourceMappingURL=Level.js.map